/**
 * Définition d'un type pour les statuts des demandes hors périmètre
 * @enum {string} ESpecialRequestStatus
 *
 */
const ESpecialRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
}

export default ESpecialRequestStatus;
